export default __webpack_public_path__ + "static/media/fMaltoBuza2.dec7f0cc.png";